import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import tools from './index';
import trackEvent from '../utils/analytics';

class ToolRefreshDependencyLines extends Tool {
  static toolName = 'Refresh dependency lines';

  static available({ controller }: IToolAvailableInput) {
    return tools.ToolRemoveDependencyLines.available({ controller });
  }

  static enabled({ controller }: IToolEnabledInput) {
    return ToolRefreshDependencyLines.available({ controller });
  }

  static action({ controller }: IToolActionInput) {
    controller.dependencyLineManager.refreshDependencyLines();
    trackEvent(
      'Feature-7229119605601784574',
      'User refreshes whiteboard dependency lines'
    );
  }

  static buttonComponent() {
    return simpleToolButton(
      ToolRefreshDependencyLines,
      'fa-regular fa-arrows-turn-to-dots'
    );
  }
}

export default ToolRefreshDependencyLines;
